import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import PerformancePresenter from "./PerformancePresenter";
import DateRangePicker from "../../../components/common/DateRangePicker";
import InputFactory from "../../../components/InputFactory";
import Hierarchy from "../../../components/common/Hierarchy";
import Progress from "../../../components/Progress";

class PerformancePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PerformancePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  getCollectionName() {
    return "performance";
  }

  // delete function
  async handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute("performance", id);
    this.refetchData();
  }

  // edit function
  async handleEditData(object) {
    this.navigateTo(`/form/${this.getCollectionName()}/${object.id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  getcurrent() {
    return this.getCurrentUser().employee;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, limit, current, count } = this.state;
    console.log("BOECLTS: ", objects);
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Human Resource {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                {/* <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                /> */}
                <div className="d-flex gap-3 mb-2">
                  <Search
                    schemas={this.getSchemas()}
                    onSubmit={this.searchSubmit.bind(this)}
                    fields={schema.fields}
                  />

                  <div className="w-100 d-flex gap-2">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <InputFactory
                          key={field}
                          // className="ms-1"
                          type={type}
                          field={field}
                          where={{}}
                          onChange={this.onChangeFilter.bind(this, type)}
                          {...options}
                        />
                      );
                    })}
                  </div>
                  <div className="col-md-2 d-flex justify-content-center">
                    <DateRangePicker
                      fields={["periodFrom", "periodTo", "supervisor.id"]}
                      onFilter={(filterObj) => {
                        console.log("FILTER: ", filterObj);
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                </div>
                <div className="row ps-2 pe-2">
                  <Hierarchy
                    className="col-lg-4 p-1 mb-2"
                    // object={object}
                    handleObjectChange={this.presenter.handleObjectChange.bind(
                      this
                    )}
                  />
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <h4 className="text-primary">{schema.label}</h4>
                    </div>
                    <div>
                      <Button
                        onClick={() => this.presenter.generateCSV(objects)}
                      >
                        Generate CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // objectId={this.handleDeleteData.bind(this)}
                objectData={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "supervisor"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(PerformancePage);
